import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import myAccountActions from 'redux/actions/myAccountActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import SuggestionList from 'components/suggestion_list/suggestion_list'

class SchoolsSuggestionList extends PureComponent {

	constructor(props) {
		super(props)
		this.searchSchools = this.searchSchools.bind(this)
		this.updateInputValue = this.updateInputValue.bind(this)
		this.updateInputId = this.updateInputId.bind(this)
		this.state = {
			inputId: props.selectedId || '',
			inputValue: props.selectedName || '',
		}
		this.searchParams = {
			countryId: '0',
			stateId: '0',
			checkRolePermission: true,
		}
	}

	searchSchools(search) {
		const params = {...this.searchParams, ...this.props.searchParams}
		this.props.actions.searchSchoolsAction(search,
			params.countryId,
			params.stateId,
			params.checkRolePermission)
	}

	updateInputValue(evt) {
		this.setState({
			inputValue: evt.target? evt.target.value : evt,
		})
	}

	updateInputId(evt) {
		this.setState({
			inputId: evt,
		})
	}

	render() {
		return (
			<SuggestionList
				fieldValue={{
					input: {
						value: this.state.inputValue,
						onChange: evt => {
							this.updateInputValue(evt)
						},
					},
					meta: {
						dirty: true,
					},
				}}
				fieldId={{
					input: {
						value: this.state.inputId,
						onChange: evt => {
							this.updateInputId(evt)
						},
					},
				}}
				placeholder={this.props.placeholder}
				searchAction={this.searchSchools}
				options={this.props.options}
				onClick={evt => this.props.onClick(evt)}
				showBottomRow={this.props.showBottomRow}
				lastRowAction={this.props.lastRowAction}
				lastRowActionCopy={this.props.lastRowActionCopy}
				autoFocus={this.props.autoFocus}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		searchSchoolsAction: myAccountActions.searchSchools,
	}, dispatch)
}

SchoolsSuggestionList.propTypes = {
	selectedId: PropTypes.string,
	selectedName: PropTypes.string,
}

SchoolsSuggestionList.defaultProps = {
	showBottomRow: true,
	searchParams: {},
}

export default connect(null, mapDispatchToProps)(SchoolsSuggestionList)
